import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/features/auth/services/auth.service';
import { CabsProfileService } from 'src/app/features/cabs/service/cabs-profile.service';

interface GroupedOption {
  id: number;
  title: string;
  list: Country[];
}

interface Country {
  countryName: string;
  country_token: string;
}

@Component({
  selector: 'app-branches-input-list',
  templateUrl: './branches-input-list.component.html',
  styles: [
  ]
})
export class BranchesInputListComponent implements OnInit, OnDestroy {
  @Input() original_branches: Country[] = [];
  @Input() loadOriginalBranchesAPI: boolean = false;
  @Input() formGroup: FormGroup;
  @Input() isSubmitted: boolean;
  @Input() enabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() key: string = "country_tokens";
  cabToken: string;
  loadingCountries = false;
  allCountries: Country[] = [];

  loadingOriginalBranches: boolean = false;
  // Master structured array matching your exact format
  groupedData: GroupedOption[] = [];

  // Container array for what is actively displayed in the UI dropdown
  filteredGroupedData: GroupedOption[] = [];
  searchControl: FormControl = new FormControl('');
  private destroy$ = new Subject<void>();
  constructor(private authService: AuthService,
    private CabProfileService: CabsProfileService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (this.loadOriginalBranchesAPI) {
      this.activatedRoute.paramMap.subscribe(params => {
        if (params.get('cab_token')) {
          this.cabToken = params.get('cab_token');
        }
      })
    }
    this.formGroup.addControl(this.key, new FormControl(
      this.original_branches.map(i => i.country_token)
    ));


    this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(text => this.filterGroupedData(text)),
        takeUntil(this.destroy$)
      )
      .subscribe(filtered => {
        this.filteredGroupedData = filtered;
      });
  }

  ngOnChanges(): void {
    if (this.original_branches && this.original_branches.length && !this.loadOriginalBranchesAPI) {
      this.loadingCountries = true;
      this.groupedData = [
        { id: 1, title: "Original branches", list: this.original_branches },
        { id: 2, title: "All countries", list: this.allCountries.filter(i => !this.original_branches.map(x => x.country_token).includes(i.country_token)) }
      ];
      this.filteredGroupedData = this.groupedData;
      console.log("Again", this.groupedData)
      this.loadingCountries = false;
    }
    if (this.enabled && !this.allCountries.length) {
      this.getCountries();
    }
  }

  getOriginalBranches() {
    this.loadingOriginalBranches = true;
    let model = { user_token: this.cabToken };
    this.CabProfileService.getListBranches(model).subscribe((res) => {
      this.original_branches = res.data;
      if (this.original_branches && this.original_branches.length) {
        this.formGroup.get(this.key)?.setValue(
          this.original_branches.map(i => i.country_token)
        );
        this.groupedData = [
          { id: 1, title: "Original branches", list: this.original_branches },
          { id: 2, title: "All countries", list: this.allCountries.filter(i => !this.original_branches.map(x => x.country_token).includes(i.country_token)) }
        ];
        this.filteredGroupedData = this.groupedData;
      }

      this.loadingOriginalBranches = false;
    });
  }


  getCountries() {
    this.loadingCountries = true;
    this.authService.getCountryCode().subscribe((res) => {
      this.allCountries = res.data;
      if (this.original_branches && this.original_branches.length) {
        this.groupedData = [
          { id: 1, title: "Original branches", list: this.original_branches },
          { id: 2, title: "All countries", list: this.allCountries.filter(i => !this.original_branches.map(x => x.country_token).includes(i.country_token)) }
        ];
        this.filteredGroupedData = this.groupedData;

      } else {
        this.groupedData = [
          { id: 1, title: "All countries", list: res.data }
        ];
        this.filteredGroupedData = this.groupedData;

      }
      console.log("API", this.groupedData)
      this.loadingCountries = false;
      this.getOriginalBranches()
    });
  }

  private filterGroupedData(searchText: string): GroupedOption[] {
    if (!searchText) {
      return this.groupedData;
    }

    const cleanSearchText = searchText.toLowerCase();

    // Loop through groups, filter internal lists, and skip groups that end up empty
    return this.groupedData
      .map(group => ({
        id: group.id,
        title: group.title,
        list: group.list.filter(item => item.countryName.toLowerCase().includes(cleanSearchText))
      }))
      .filter(group => group.list.length > 0); // Only keep groups that have matching items
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  notIncludedInFilteredList(countryToken: string): boolean {
    return !this.filteredGroupedData.some(group =>
      group.list.some(item => item.country_token === countryToken)
    );
  }

  notHaveList(id: number): boolean {
    return !this.filteredGroupedData.some(group => group.id === id);
  }

  get getListInFilter(): Country[] {
    const id = this.filteredGroupedData[0]?.id;
    if (!id) return [];
    return this.groupedData.filter(i => i.id == id)[0]?.list || [];
  }


}
